module.exports = function (productGroupService) {
    return {
        restrict: 'E',
        link(scope) {
            scope.isGroupLoading = function () {
                return productGroupService.selectedGroup === undefined;
            };

            scope.isCountLoading = function () {
                return productGroupService.selectedGroupTotalCount === undefined;
            };

            scope.productGroupName = function () {
                return productGroupService.selectedGroup.Description;
            };

            scope.productsCount = function () {
                return productGroupService.selectedGroupTotalCount;
            };
        },
        template: require('./productgroup-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/productgroups/productgroup-directive.js
 **/